import EapAssignmentCard from '../views/EapAssignmentCard.vue';
import EapAssignmentMonitoring from '../views/EapAssignmentMonitoring.vue';
import EapAssignments from '../views/EapAssignments.vue';

export const routes = [
  {
    path: '/zamer/orders/',
    name: 'EapAssignments',
    component: EapAssignments,
  },
  {
    path: '/zamer/orders/:action/:id',
    name: 'EapAssignmentCard',
    component: EapAssignmentCard,
  },
  {
    path: '/zamer/ordersMonitoring/',
    name: 'EapAssignmentMonitoring',
    component: EapAssignmentMonitoring,
  },
];
